import type {
    SwitchCommerceMarketRequest,
    SwitchCommerceMarketResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const switchCommerceMarketOperation = defineCommerceOperation<
    SwitchCommerceMarketRequest,
    SwitchCommerceMarketResponse
>("commerce.context.switch-market");
